import PropTypes from "prop-types";
import ImageUpload from "../../../cleaner/components/ImageUpload";

const AddImages = ({ images, setImages, t }) => (
    <div>
        <p className="text-md font-medium mb-2">{t("uploadImages")}</p>
        <ImageUpload fileList={images} handleFileChange={setImages} maxCount={4} />
    </div>
);

AddImages.propTypes = {
    images: PropTypes.array.isRequired,
    setImages: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default AddImages;
